import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientSSN from 'utils/print/getPatientSSN';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullPhone from 'utils/print/getPrescriberFullPhone';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketPlanOfCareFittedServices = {
  ID: 17,
  Name: 'Plan Of Care / Fitted Services',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Plan-Of-Care-Fitted-Services/1.js',
      Logo: {
        x: 25,
        y: 20,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 7,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 150,
          y: 21,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 150,
          y: 24,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 150,
          y: 27,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 150,
          y: 30,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 31,
          y: 52.5,
          width: 57,
        },
        {
          name: 'Patient Date of Birth',
          type: 'text',
          getValue: getPatientFullDob,
          x: 96,
          y: 52.5,
          width: 30,
          normalize: normalize.date,
        },
        {
          name: 'Patient Gender',
          getValue: getPatientGender,
          type: 'radio',
          options: [
            {
              x: 135,
              y: 53.5,
              width: 3,
              height: 3,
              value: 'M',
            },
            {
              x: 146,
              y: 53.5,
              width: 3,
              height: 3,
              value: 'F',
            },
          ],
        },
        {
          name: 'Date of Visit',
          type: 'text',
          x: 180,
          y: 52.5,
          width: 18,
          normalize: normalize.date,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientAddress,
          x: 34,
          y: 56,
          width: 62,
        },
        {
          name: 'Patient SS',
          type: 'text',
          getValue: getPatientSSN,
          x: 109,
          y: 56,
          width: 22,
        },
        {
          name: 'Adv Dir',
          type: 'checkbox',
          x: 142,
          y: 57,
          width: 3,
          height: 3,
        },
        {
          name: 'Patient Record Number',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 163,
          y: 56,
          width: 34,
        },
        {
          name: 'Patient Phone',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 34,
          y: 59.5,
          width: 38,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Alt Contact',
          type: 'text',
          x: 96,
          y: 59.5,
          width: 49,
        },
        {
          name: 'Patient Alt Phone',
          type: 'text',
          x: 163,
          y: 59.5,
          width: 34,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Diagnosis',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 31,
          y: 73.5,
          width: 58,
        },
        {
          name: 'Surgery',
          type: 'text',
          x: 109,
          y: 73.5,
          width: 53,
        },
        {
          name: 'Physician Visit Date',
          type: 'text',
          x: 172,
          y: 73.5,
          width: 24,
          normalize: normalize.date,
        },
        {
          name: 'Physician Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 31,
          y: 77,
          width: 58,
        },
        {
          name: 'Physician Phone',
          type: 'text',
          getValue: getPrescriberFullPhone,
          x: 109,
          y: 77,
          width: 53,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Physician Next Visit Date',
          type: 'text',
          x: 180,
          y: 77,
          width: 18,
          normalize: normalize.date,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Bra size',
          type: 'text',
          x: 32,
          y: 94,
          width: 36,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Cup size',
          type: 'text',
          x: 32,
          y: 97.5,
          width: 36,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Other Products',
          type: 'text',
          x: 37,
          y: 101,
          width: 31,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Product Re-order #',
          type: 'text',
          x: 42,
          y: 104.5,
          width: 26,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Style/Color',
          type: 'text',
          x: 32,
          y: 108,
          width: 15,
        },
        {
          name: 'POST-MASTECTOMY FORMS and BRAS Size',
          type: 'text',
          x: 54,
          y: 108,
          width: 14,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Waist Measurement',
          type: 'text',
          x: 41.5,
          y: 114.5,
          width: 6,
          normalize: normalize.number,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Product #',
          type: 'text',
          x: 62,
          y: 114.5,
          width: 6,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Hip Measurement',
          type: 'text',
          x: 41.5,
          y: 118,
          width: 6,
          normalize: normalize.number,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Style/Color',
          type: 'text',
          x: 62,
          y: 118,
          width: 6,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Length from under arm to coccyx',
          type: 'text',
          x: 55,
          y: 121,
          width: 8,
          normalize: normalize.number,
        },
        {
          name: 'LUMBO-SACRAL GARMENTS Size',
          type: 'text',
          x: 25,
          y: 124.5,
          width: 42,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Stocking Style',
          type: 'radio',
          options: [
            {
              x: 90.5,
              y: 95.5,
              width: 3,
              height: 3,
              value: 'Thigh',
            },
            {
              x: 111,
              y: 95.5,
              width: 3,
              height: 3,
              value: 'Calf',
            },
            {
              x: 127,
              y: 95.5,
              width: 3,
              height: 3,
              value: 'Pantyhose',
            },
            {
              x: 149,
              y: 95.5,
              width: 3,
              height: 3,
              value: 'Maternity',
            },
          ],
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Quantity',
          type: 'radio',
          options: [
            {
              x: 90.5,
              y: 98.75,
              width: 3,
              height: 3,
              value: '1 Pair',
            },
            {
              x: 111,
              y: 98.75,
              width: 3,
              height: 3,
              value: '2 Pair',
            },
            {
              x: 127,
              y: 98.75,
              width: 3,
              height: 3,
              value: '3 Pair',
            },
            {
              x: 149,
              y: 98.75,
              width: 3,
              height: 3,
              value: '4 Pair',
            },
            {
              x: 169,
              y: 98.75,
              width: 3,
              height: 3,
              value: 'Other',
            },
          ],
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Quantity Other',
          type: 'text',
          x: 181,
          y: 98,
          width: 15,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Brand',
          type: 'radio',
          options: [
            {
              x: 90.5,
              y: 102.25,
              width: 3,
              height: 3,
              value: 'Jobst',
            },
            {
              x: 111,
              y: 102.25,
              width: 3,
              height: 3,
              value: 'Medi',
            },
            {
              x: 127,
              y: 102.25,
              width: 3,
              height: 3,
              value: 'ITA-MED',
            },
            {
              x: 149,
              y: 102.25,
              width: 3,
              height: 3,
              value: 'Truform',
            },
            {
              x: 169,
              y: 102.25,
              width: 3,
              height: 3,
              value: 'Other',
            },
          ],
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Brand Other',
          type: 'text',
          x: 181,
          y: 101,
          width: 15,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Product Reorder',
          type: 'text',
          x: 96,
          y: 104.25,
          width: 39,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Style/Color',
          type: 'text',
          x: 152,
          y: 104.25,
          width: 28,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Size',
          type: 'text',
          x: 186,
          y: 104.25,
          width: 10,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Calf Style Left Ankle',
          type: 'text',
          x: 73,
          y: 114.5,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Calf Style Right Ankle',
          type: 'text',
          x: 89,
          y: 114.5,
          width: 7,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Calf Style Left Calf',
          type: 'text',
          x: 73,
          y: 118,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Calf Style Right Calf',
          type: 'text',
          x: 89,
          y: 118,
          width: 7,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Calf Style Length top of calf to heel',
          type: 'text',
          x: 73,
          y: 121.25,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Thigh Style Left Ankle',
          type: 'text',
          x: 109,
          y: 114.5,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Thigh Style Right Ankle',
          type: 'text',
          x: 125.5,
          y: 114.5,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Thigh Style Left Calf',
          type: 'text',
          x: 109,
          y: 118,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Thigh Style Right Calf',
          type: 'text',
          x: 125.5,
          y: 118,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Thigh Style Length top of calf to heel',
          type: 'text',
          x: 109,
          y: 121.25,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Panty Hose Left Ankle',
          type: 'text',
          x: 146,
          y: 114.5,
          width: 6,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Panty Hose Right Ankle',
          type: 'text',
          x: 163.5,
          y: 114.5,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Panty Hose Left Calf',
          type: 'text',
          x: 146,
          y: 118,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Panty Hose Right Calf',
          type: 'text',
          x: 163.5,
          y: 118,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'THERAPEUTIC/COMPRESSION STOCKINGS Panty Hose Length top of calf to heel',
          type: 'text',
          x: 146,
          y: 121.25,
          width: 5,
          normalize: normalize.number,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Shoe Size',
          type: 'text',
          x: 31,
          y: 134.5,
          width: 36,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Width',
          type: 'text',
          x: 77,
          y: 134.5,
          width: 48,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Color',
          type: 'text',
          x: 135,
          y: 134.5,
          width: 17,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Closure Type',
          type: 'text',
          x: 168,
          y: 134.5,
          width: 28,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Shoe Reorder',
          type: 'text',
          x: 36,
          y: 138,
          width: 78,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Shoe Style/Color',
          type: 'text',
          x: 131,
          y: 138,
          width: 21,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Shoe Reorder Size',
          type: 'text',
          x: 163,
          y: 138,
          width: 33,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Insert Type',
          type: 'text',
          x: 32,
          y: 141,
          width: 35,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Insert Reorder',
          type: 'text',
          x: 41,
          y: 144.5,
          width: 73,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Insert Style/Color',
          type: 'text',
          x: 131,
          y: 144.5,
          width: 21,
        },
        {
          name: 'DIABETIC THERAPEUTIC SHOES & INSERTS Insert Size',
          type: 'text',
          x: 163,
          y: 144.5,
          width: 33,
        },
        {
          name: 'Customer was instructed on application techniques',
          type: 'checkbox',
          x: 53,
          y: 152,
          width: 3,
          height: 3,
        },
        {
          name: 'Customer was instructed on proper care',
          type: 'checkbox',
          x: 89,
          y: 152,
          width: 3,
          height: 3,
        },
        {
          name: 'Customer was instructed on how to re-order',
          type: 'checkbox',
          x: 121,
          y: 152,
          width: 3,
          height: 3,
        },
        {
          name: 'Rights & Responsibilities',
          type: 'checkbox',
          x: 28,
          y: 177.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Service Availability of Company',
          type: 'checkbox',
          x: 28,
          y: 181.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Privacy Notice',
          type: 'checkbox',
          x: 28,
          y: 185.25,
          width: 2,
          height: 2,
        },
        {
          name: '30 Medicare Supplier Standards',
          type: 'checkbox',
          x: 28,
          y: 189.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Supply Instructions',
          type: 'checkbox',
          x: 85,
          y: 177.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Lease/Purchase Agreement',
          type: 'checkbox',
          x: 85,
          y: 181.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Maintenance of Supply',
          type: 'checkbox',
          x: 85,
          y: 185.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Infection Control Tips',
          type: 'checkbox',
          x: 85,
          y: 189.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Complaint process (reviewed/resolved)',
          type: 'checkbox',
          x: 137,
          y: 177.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Follow-up & discharge instructions',
          type: 'checkbox',
          x: 137,
          y: 181.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Warranty Form',
          type: 'checkbox',
          x: 137,
          y: 185.25,
          width: 2,
          height: 2,
        },
        {
          name: 'AOB Signature',
          type: 'checkbox',
          x: 137,
          y: 189.25,
          width: 2,
          height: 2,
        },
        {
          name: 'ADDITIONAL NOTES NEED 1',
          type: 'text',
          x: 18,
          y: 201.5,
          width: 53,
        },
        {
          name: 'ADDITIONAL NOTES GOAL 1',
          type: 'text',
          x: 73,
          y: 201.5,
          width: 61,
        },
        {
          name: 'ADDITIONAL NOTES RESULTS 1',
          type: 'text',
          x: 136,
          y: 201.5,
          width: 61,
        },
        {
          name: 'ADDITIONAL NOTES NEED 2',
          type: 'text',
          x: 18,
          y: 205.25,
          width: 53,
        },
        {
          name: 'ADDITIONAL NOTES GOAL 2',
          type: 'text',
          x: 73,
          y: 205.25,
          width: 61,
        },
        {
          name: 'ADDITIONAL NOTES RESULTS 2',
          type: 'text',
          x: 136,
          y: 205.25,
          width: 61,
        },
        {
          name: 'Follow-Up Visit Recommended',
          type: 'checkbox',
          x: 59,
          y: 221.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Follow-Up Visit Recommended Line 1',
          type: 'text',
          x: 63,
          y: 219.5,
          width: 33,
        },
        {
          name: 'Follow-Up Visit Recommended Line 2',
          type: 'text',
          x: 63,
          y: 223,
          width: 33,
        },
        {
          name: 'Follow-Up by Phone & As Needed',
          type: 'checkbox',
          x: 153,
          y: 221.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Next Dr. Visit',
          type: 'text',
          x: 36,
          y: 226,
          width: 73,
        },
        {
          name: 'Equip To be P/U Line 1',
          type: 'text',
          x: 135,
          y: 226,
          width: 62,
        },
        {
          name: 'Equip To be P/U Line 2',
          type: 'text',
          x: 135,
          y: 229.5,
          width: 62,
        },
        {
          name: 'Name of authorized person',
          type: 'text',
          x: 127,
          y: 232.5,
          width: 70,
        },
        {
          name: 'Signature of Authorized person',
          type: 'signature',
          x: 52,
          y: 239,
          width: 60,
          height: 8,
        },
        {
          name: 'Authorized person Relationship',
          type: 'text',
          x: 142,
          y: 242,
          width: 53,
        },
        {
          name: 'Signature of Patient',
          type: 'signature',
          getValue: getSignature,
          x: 52,
          y: 250,
          width: 60,
          height: 8,
        },
        {
          name: 'Authorized person Date',
          type: 'text',
          getValue: getSignatureDate,
          x: 142,
          y: 252,
          width: 53,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketPlanOfCareFittedServices;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Plan-Of-Care-Fitted-Services.js